<template>
  <div class="page-static">
    <div class="page-body" v-html="$t('view.terms.body')" />
  </div>
</template>

<script>
export default { name: 'Terms' }
</script>

<style scoped>
.page-static { background: #f0f2f8; min-height: calc(100vh - 64px - 60px); }
.page-body { max-width: 800px; margin: 0 auto; padding: 48px 24px 80px; }
.page-body >>> h1 { font-size: 28px; color: #1a1f36; margin: 0 0 8px; }
.page-body >>> .update { color: #909399; font-size: 13px; margin: 0 0 36px; }
.page-body >>> h2 { font-size: 18px; color: #303133; margin: 32px 0 12px; }
.page-body >>> p { font-size: 14px; line-height: 1.9; color: #4a5568; margin: 0 0 12px; }
.page-body >>> ul { margin: 0 0 12px; padding-left: 24px; }
.page-body >>> li { font-size: 14px; line-height: 1.9; color: #4a5568; }
</style>
